import React from 'react';
import './Style/Loading.css';

function Loading  ({ message = "Loading..." }) {
    return (
       <>
       
        <div className="loading-state">
            <div className="spinner"></div>
            <p>{message}</p>
        </div>
       
       </>
    );
};

export default Loading;